import React from 'react';
import useSEO from '../hooks/useSEO';
import NavBar from '../components/Navbar/NavBar';
import Clients from '../components/Clients';
import { Mail, Phone, MapPin, ArrowRight } from 'lucide-react';

const Contact = () => {
    useSEO({
        title: "Contact Us | Yaniva Ventures Private Limited",
        description: "Get in touch with our expert corporate finance advisors. Call us, send an email, or visit our Ahmedabad office to discuss SME IPO and corporate advisory solutions."
    });

    const redirectToGoogleForm = () => {
        window.open('https://forms.gle/yN5rKfAiyeQQMQEw8', '_blank');
    };

    return (
        <div className="min-h-screen bg-slate-50 flex flex-col">
            <NavBar />
            
            <div className="flex-grow container mx-auto px-6 py-12 max-w-7xl flex items-center justify-center">
                <div className="bg-white rounded-3xl border border-slate-100 shadow-xl overflow-hidden w-full max-w-5xl flex flex-col lg:flex-row">
                    
                    {/* Left Column - Details */}
                    <div className="p-8 md:p-12 lg:w-3/5 flex flex-col justify-between">
                        <div>
                            <span className="text-xs font-semibold text-cyan-600 tracking-wider uppercase mb-2 block">Connect With Us</span>
                            <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-6">
                                Let's Build the Future
                            </h1>
                            <p className="text-slate-600 text-sm md:text-base leading-relaxed mb-8 text-justify">
                                <strong>Yaniva Ventures Private Limited</strong> specializes in providing comprehensive SME IPO advisory and corporate finance services. We guide our corporate clients through NSE Emerge and BSE SME listings, corporate restructuring, and financial optimization. Our team of experienced professionals leverages deep market insights to maximize value for growing enterprises.
                            </p>
                        </div>
                        
                        <button 
                            type="button" 
                            onClick={redirectToGoogleForm}
                            className="w-full sm:w-auto px-8 py-4 bg-cyan-600 hover:bg-cyan-700 text-white font-bold rounded-xl shadow-lg shadow-cyan-600/10 hover:shadow-cyan-600/25 transition-all duration-300 flex items-center justify-center gap-2"
                        >
                            Let's Connect <ArrowRight size={18} />
                        </button>
                    </div>           
                    
                    {/* Right Column - Info Card */}
                    <div className="p-8 md:p-12 lg:w-2/5 bg-gradient-premium text-white flex flex-col justify-between relative overflow-hidden">
                        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-indigo-500/10 opacity-30"></div>
                        <div className="relative z-10 space-y-8">
                            <h2 className="text-2xl font-bold border-b border-white/10 pb-4 mb-6">Contact Information</h2>
                            
                            <div className="flex items-start gap-4">
                                <span className="p-2 bg-white/10 rounded-xl shrink-0"><MapPin size={20} className="text-cyan-400" /></span>
                                <div>
                                    <h4 className="font-semibold text-sm text-slate-300">Office Location</h4>
                                    <p className="text-sm mt-1 text-slate-100 leading-relaxed">
                                        D-910, Swati Clover, Near Shilaj Circle, Sardar Patel Ring Road, Ahmedabad - 380 059, Gujarat, India
                                    </p>
                                </div>
                            </div>
                            
                            <div className="flex items-start gap-4">
                                <span className="p-2 bg-white/10 rounded-xl shrink-0"><Phone size={20} className="text-cyan-400" /></span>
                                <div>
                                    <h4 className="font-semibold text-sm text-slate-300">Call Us</h4>
                                    <p className="text-sm mt-1 text-slate-100">
                                        +91 91069 30955
                                    </p>
                                </div>
                            </div>
                            
                            <div className="flex items-start gap-4">
                                <span className="p-2 bg-white/10 rounded-xl shrink-0"><Mail size={20} className="text-cyan-400" /></span>
                                <div>
                                    <h4 className="font-semibold text-sm text-slate-300">Send Email</h4>
                                    <a href="mailto:info@yanivaventures.com" className="text-sm mt-1 text-slate-100 hover:text-cyan-400 transition-colors block">
                                        info@yanivaventures.com
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            
            <Clients />
        </div>
    );
};

export default Contact;